import {
  ScrollDirection,
  ScrollParams,
  ScrollSpeed,
} from '@modules/dashboard/types';

const SLOW_HEIGHT_ZONE = 150;
const FAST_HEIGHT_ZONE = 50;

export function getAutoScrollParams(positionY: number): ScrollParams | null {
  const distanceFromTop = positionY;
  const distanceFromBottom = window.innerHeight - positionY;

  const isScrolledToTop = window.scrollY === 0;
  const isScrolledToBottom =
    window.scrollY + window.innerHeight ===
    document.documentElement.scrollHeight;

  if (distanceFromTop < SLOW_HEIGHT_ZONE && !isScrolledToTop) {
    return {
      direction: ScrollDirection.Up,
      speed:
        distanceFromTop < FAST_HEIGHT_ZONE
          ? ScrollSpeed.Fast
          : ScrollSpeed.Slow,
    };
  }

  if (distanceFromBottom < SLOW_HEIGHT_ZONE && !isScrolledToBottom) {
    return {
      direction: ScrollDirection.Down,
      speed:
        distanceFromBottom < FAST_HEIGHT_ZONE
          ? ScrollSpeed.Fast
          : ScrollSpeed.Slow,
    };
  }

  return null;
}
